import { NormalCards } from "../../../../../../components";
import styles from "./style.module.scss";

const BasicCards = ({ cardsEnum }) => {
  return (
    <div className={styles.cardsContainer}>
      <NormalCards
        data={cardsEnum}
        vertical={true}
        customCardStyle={styles.customCardStyle}
        customTitleStyle={styles.customTitleStyle}
        customContentStyle={styles.customContentStyle}
      />
    </div>
  );
};

export default BasicCards;
